import React, { lazy, Suspense, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import { Switch, Route, useLocation } from "react-router-dom";
import PublicRoute from "./pages/User/PublicRoute";
import PrivateRoute from "./pages/User/PrivateRoute";
import ReactPixel from "react-facebook-pixel";

// Lazy loaded pages
const Home = lazy(() => import("./pages/Home"));
const Checkout = lazy(() => import("./pages/Shop/Checkout"));
const PaymentSuccess = lazy(() =>
  import("./pages/Shop/SubPages/PaymentSuccess")
);
const PaymentError = lazy(() => import("./pages/Shop/SubPages/PaymentFail"));
const PaymentStatus = lazy(() =>
  import("./pages/Shop/SubPages/Payment-status")
);
const ProductPage = lazy(() => import("./pages/Shop/ProductPage"));
const Shop = lazy(() => import("./pages/Shop/Shop"));
const Register = lazy(() => import("./pages/User/Register"));
const VerifyEmail = lazy(() => import("./pages/User/VerifyEmail"));
const Login = lazy(() => import("./pages/User/Login"));
const MyAccount = lazy(() => import("./pages/User/MyAccount"));
const Privacypolicy = lazy(() =>
  import("./pages/AdditionalPages/Privacypolicy")
);
const Returnpolicy = lazy(() => import("./pages/AdditionalPages/ReturnPolicy"));
const Regulations = lazy(() => import("./pages/AdditionalPages/Regulations"));
const AboutUs = lazy(() => import("./pages/AdditionalPages/AboutUs"));
const DeliveryandShippment = lazy(() =>
  import("./pages/AdditionalPages/DeliveryandShippment")
);
const Returns = lazy(() => import("./pages/AdditionalPages/Returns"));
const Faq = lazy(() => import("./pages/AdditionalPages/Faq"));
const ContactUs = lazy(() => import("./pages/AdditionalPages/ContactUs"));
const CheckOrder = lazy(() => import("./pages/AdditionalPages/CheckOrder"));
const AccessibilityPolicy = lazy(() => import("./pages/AdditionalPages/AccessibilityPolicy"));    
const ForgotPassword = lazy(() => import("./pages/User/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/User/ResetPassword"));
function App() {
  const location = useLocation();

  // Track SPA page changes + AOS site-wide
  useEffect(() => {
    ReactPixel.pageView();
  }, [location.pathname]);

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-out-cubic",
      once: true,
      offset: 40,
    });
  }, []);

  return (
    <div className="App page-transition">
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Suspense fallback={<span className="loader"></span>}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/product/:uniqueId" component={ProductPage} />
          <Route path="/store/:numberInList" component={Shop} />
          <Route path="/store" component={Shop} />

          <PublicRoute path="/register" exact component={Register} />
          <PublicRoute path="/login" exact component={Login} />

          <Route path="/verify-email/:token" component={VerifyEmail} />
          {/* Thank-you page after successful order */}
          <Route path="/thankyou" component={PaymentSuccess} />
          {/* Backwards compatibility if /payment-success is already used anywhere */}
          <Route path="/payment-success" component={PaymentSuccess} />
          <Route path="/payment-error" component={PaymentError} />
          <Route path="/payment-status" component={PaymentStatus} />
          <PrivateRoute path="/account" component={MyAccount} />

          <Route path="/privacy-policy" component={Privacypolicy} />
          <Route path="/return-policy" component={Returnpolicy} />
          <Route path="/regulations" component={Regulations} />
          <Route path="/accessibility-policy" component={AccessibilityPolicy} />
          <Route path="/about-us" component={AboutUs} />
          <Route
            path="/delivery-and-shippment"
            component={DeliveryandShippment}
          />
          <Route path="/returns" component={Returns} />
          <Route path="/faq" component={Faq} />
          <Route path="/contact-us" component={ContactUs} />
          <Route path="/order-status/:orderId" component={CheckOrder} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/reset-password/:token" component={ResetPassword} />
          <Route>
            <div style={{ padding: 50, textAlign: "center" }}>
              הדף אינו קיים
            </div>
          </Route>
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
